import { Link } from 'react-router-dom';
import { BRAND } from '../../data/site';
import { Mail, Phone, MapPin, ArrowUpRight } from 'lucide-react';
import { useT } from '../../i18n/LanguageContext';
import { useExternalLink } from '../../contexts/ExternalLinkContext';

export default function Footer() {
  const { t } = useT();
  const { confirm } = useExternalLink();
  const links = [
    { label: t('nav.about'), to: '/about' },
    { label: t('nav.strategy'), to: '/strategy' },
    { label: t('nav.ventures'), to: '/ventures' },
    { label: t('nav.services'), to: '/services' },
    { label: t('nav.security'), to: '/security' },
    { label: t('nav.news'), to: '/news' },
    { label: t('nav.media'), to: '/media' },
    { label: t('nav.contact'), to: '/contact' },
  ];
  return (
    <footer data-testid="site-footer" className="relative border-t border-subtle pt-20 pb-10 overflow-hidden bg-base">
      <div className="absolute inset-0 bg-grid opacity-30 pointer-events-none" />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <img src={BRAND.logo} alt="MBK Holding" className="h-14 w-auto" />
              <div>
                <p className="font-display text-2xl text-prim tracking-tight">MBK Holding</p>
                <p className="font-mono text-[10px] tracking-[0.3em] text-brand-teal-light uppercase">Doha to the World</p>
              </div>
            </div>
            <p className="mt-8 text-sec max-w-md leading-relaxed">
              {t('about.intro')}
            </p>
            <p className="mt-6 font-arabic text-2xl text-brand-teal-light/80">وَاللَّهُ خَيْرُ الرَّازِقِينَ</p>
            <p className="mt-1 text-xs text-muted italic">— And God is the best of providers.</p>
          </div>

          <div className="lg:col-span-3">
            <p className="eyebrow mb-6">{t('footer.nav')}</p>
            <ul className="space-y-3">
              {links.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sec hover:text-brand-teal-light transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="eyebrow mb-6">{t('footer.hq')}</p>
            <ul className="space-y-4 text-sec">
              <li className="flex gap-3 items-start">
                <MapPin size={16} className="text-brand-teal-light shrink-0 mt-1" />
                <span>{BRAND.contact.address}<br />{BRAND.contact.city}</span>
              </li>
              <li className="flex gap-3 items-center">
                <Phone size={16} className="text-brand-teal-light shrink-0" />
                <a href={`tel:${BRAND.contact.phone.replace(/\s/g,'')}`} className="hover:text-prim">{BRAND.contact.phone}</a>
              </li>
              <li className="flex gap-3 items-center">
                <Mail size={16} className="text-brand-teal-light shrink-0" />
                <a href={`mailto:${BRAND.contact.emailFinance}`} className="hover:text-prim">{BRAND.contact.emailFinance}</a>
              </li>
              <li className="flex gap-3 items-center">
                <ArrowUpRight size={16} className="text-brand-teal-light shrink-0" />
                <a
                  href={`https://${BRAND.contact.site}`}
                  onClick={(e) => { e.preventDefault(); confirm(`https://${BRAND.contact.site}`, BRAND.contact.site); }}
                  className="hover:text-prim"
                >{BRAND.contact.site}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="divider-line my-12" />

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-muted">
          <p>© {new Date().getFullYear()} MBK Holding. {t('footer.rights')}</p>
          <p className="font-mono tracking-widest uppercase">QNV 2030 · NDS3 2024–2030 · Anchored in Qatar</p>
        </div>
      </div>
    </footer>
  );
}
